<ng-container *ngIf="!fileName && saveUrl && !downloadOnly">
  <div class="{{dragAreaClass}} file-display">
    <input type="file" class="file-input"
        [accept]="allowedFileType"
        [disabled]="isDisabled"
        (change)="onFileSelected($event)" #fileUpload>

  No file.

      <aims-common-button-mini
          style="margin-left: 5px;"
          title="Upload"
          aria-label="Upload"
          [disabled]="isDisabled"
          (click)="fileUpload.click()" >
        <mat-icon color="primary">attach_file</mat-icon>
      </aims-common-button-mini>

{{dragAreaLabel }} file here
  <span class="too-big" *ngIf="showTooBig">*file too big</span>
  </div>
</ng-container>


<ng-container *ngIf="uploadProgress">
  <div class="progress">
    <mat-progress-bar class="progress-bar" mode="determinate"
        [value]="uploadProgress" *ngIf="uploadProgress">
    </mat-progress-bar>

    <div class="file-display" >
      <mat-icon class="cancel-icon" (click)="cancelUpload()"
          *ngIf="uploadProgress">delete_forever</mat-icon>
        {{ uploadProgress }}%
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!uploadProgress && fileName">
  <div class="file-display">
    <span class="downloadText" *ngIf="downloadUrl" (click)="downloadFile($event)">{{fileName}}</span>
    <span *ngIf="!downloadUrl">{{fileName}}</span>
    <ng-container *ngIf="removeUrl && !downloadOnly">
      <aims-common-button-mini
          style="margin-left: 10px;"
          title="Delete"
          aria-label="Delete"
          (click)="fileDelete()"
          *ngIf="removeUrl">
        <mat-icon color="warn">delete</mat-icon>
      </aims-common-button-mini>
    </ng-container>
  </div>
</ng-container>

<aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
